// @flow
import LoginPass from './LoginPass';

export default LoginPass;
